var X = "//s3.amazonaws.com/edge-assets.lemonade.com/x-ea627cf93a86e17b3672a26cd4e3757e.svg";

export { X as default };
